import { LogLevel } from '@jwp/ott-common/src/services/logging/LogLevel';
import LogTransporter from '@jwp/ott-common/src/services/logging/LogTransporter';

export default class SentryLogTransporter extends LogTransporter {
  async getSentry() {
    if (!import.meta.env.APP_SENTRY_DSN || import.meta.env.DEV || import.meta.env.MODE === 'test') {
      return null;
    }

    return await import('@sentry/react');
  }

  log(level: LogLevel, scope: string, message: string, extra?: Record<string, unknown>, error?: Error): void {
    if (level !== LogLevel.ERROR && level !== LogLevel.FATAL) return;

    this.getSentry().then((sentry) => {
      sentry?.captureMessage(`[${scope}]: ${message}`, level === LogLevel.FATAL ? 'fatal' : 'error');
      if (extra) sentry?.setContext('extra', extra);
      if (error) sentry?.captureException(error);
    });
  }
}
